export const NO_URL_MESSAGE = "Unable to upload. A valid url was not provided";

export const NO_XHR_MESSAGE = "Unable to upload. xhr object was not provided";